// import { Text3D, Center } from "@react-three/drei"

export default function Placeholder(){

    return <>
        <h1 className="loading__message">Greenwood | Loading...</h1>
    </>    

}